import { dsl } from '@wix/yoshi-serverless/wrap';

export const ricosNextFeatureApi = dsl({
          functionName: 'ricosNextFeatureApi',
          fileName: 'api/user/ricos-next.api',
        });